import { addDays } from 'utils/utils';
import { dateFormat } from 'utils/dynamic/i18n';

export class AutocompleteDynamicModel {
  recaptchaToken: string;
  ticketType: string;
  term: string;
  categoryDesc?: string;
  value?: number;

  constructor(param?: string, defaultType?: string) {
    this.recaptchaToken = '';
    this.term = '';
    this.categoryDesc = '';

    const data = param?.split('/');
    if (param && data?.length === 2) {
      const type = data[0][0].toUpperCase() + data[0].slice(1);
      this.ticketType = type;
      this.value = +data[1];
    } else if (data?.length === 1) {
      if (['Events', 'Sport'].includes(data[0])) {
        this.ticketType = data[0];
      } else {
        this.ticketType = 'Sport';
        this.value = +data[0];
      }
    } else if (defaultType) {
      this.ticketType = defaultType;
    } else {
      this.ticketType = 'Sport';
    }
  }
}

export class SearchDynamicModel {
  recaptchaToken?: string;
  searchOption: string;
  lat: number;
  lon: number;
  autocompleteId?: number;
  countryCode: string;
  cityArrivalCode: string;
  arrivalDate: string;
  departureDate: string;
  iataCodes: string;
  numberOfAdults: number;
  numberOfSeniors: number;
  numberOfChildren: number;
  numberOfInfants: number;
  matrixConfig: { matrixConfig: string };
  eventDate?: Date;
  searchToken?: string;
  departureCode?: string;
  cabineType: number;
  numberOfBags: number;
  directFlight: boolean;
  roomsString: string;
  to?: string;
  city: string;
  googleAutocomplete?: any;
  searchTypeId?: number;
  searchRadius?: number;

  constructor(urlParams?: URLSearchParams, googleAutocomplete?: any, searchTypeId?: number) {
    this.searchTypeId = searchTypeId;
    this.googleAutocomplete = googleAutocomplete;
    this.searchRadius = 1;

    if (urlParams) {
      const data = Object.fromEntries(urlParams);
      this.searchOption = data.searchOption;
      this.lat = +data.lat;
      this.lon = +data.lon;
      this.autocompleteId = data.autocomleteId ? +data.autocomleteId : undefined;
      this.countryCode = data.countryCode;
      this.cityArrivalCode = data.cityArrivalCode;
      this.arrivalDate = data.arrivalDate;
      this.departureDate = data.departureDate;
      this.iataCodes = data.iataCodes;
      this.numberOfAdults = +data.numberOfAdults;
      this.numberOfSeniors = +data.numberOfSeniors;
      this.numberOfChildren = +data.numberOfChildren;
      this.numberOfInfants = +data.numberOfInfants;
      this.departureCode = data.departureCode;
      this.matrixConfig = { matrixConfig: data.matrixConfig };
      this.cabineType = +data.cabineType;
      this.numberOfBags = +data.numberOfBags;
      this.directFlight = data.directFlight === 'true';
      this.roomsString = data.roomsString;
      this.city = data.city;

      if (data.searchToken?.length > 10) {
        this.searchToken = data.searchToken;
      }
    } else {
      this.searchOption = 'Sport';
      this.lat = 0;
      this.lon = 0;
      this.countryCode = '';
      this.cityArrivalCode = '';
      this.arrivalDate = dateFormat(addDays(21), 'yyyy-MM-dd');
      this.departureDate = dateFormat(addDays(14), 'yyyy-MM-dd');
      this.iataCodes = '';
      this.numberOfAdults = 0;
      this.numberOfSeniors = 0;
      this.numberOfChildren = 0;
      this.numberOfInfants = 0;
      this.departureCode = 'TLV';
      this.matrixConfig = { matrixConfig: 'Dynamic_FMHM' };
      this.cabineType = 0;
      this.numberOfBags = 0;
      this.directFlight = false;
      this.roomsString = '';
      this.city = '';
    }
  }
}

export class SearchDynamicAMModel {
  searchOption: string;
  lat: number;
  lon: number;
  autocompleteId: number;
  countryCode: string;
  iataCodes: string;
  matrixConfig: { matrixConfig: string };

  constructor(urlParams: URLSearchParams) {
    const data = Object.fromEntries(urlParams);
    this.searchOption = data.searchOption;
    this.lat = +data.lat;
    this.lon = +data.lon;
    this.autocompleteId = +data.autocompleteId;
    this.countryCode = data.countryCode;
    this.iataCodes = data.iataCodes;
    this.matrixConfig = { matrixConfig: 'Dynamic_AM' };
  }
}
